var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61969 3.28906C6.25706 3.92434 6.87616 4.54136 7.5177 5.18081C7.32315 5.36909 7.10983 5.57042 6.90172 5.77749C6.0453 6.63026 4.11756 8.55121 3.26688 9.40972C2.92994 9.74978 2.5372 9.92868 2.05631 9.91304C1.8216 9.90521 1.58637 9.91721 1.35219 9.90469C1.08253 9.89009 0.893202 9.71119 0.879641 9.44153C0.864515 9.13798 0.859821 8.83182 0.884856 8.5293C0.911978 8.19341 1.04133 7.88933 1.28438 7.64524C2.38073 6.54055 4.54734 4.36767 5.61969 3.28906Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61289 4.02035C8.02821 3.40802 7.42996 2.78161 6.86719 2.19171C7.17231 1.86104 7.48473 1.44534 7.87278 1.12145C8.36306 0.712533 9.14594 0.819455 9.58093 1.28053C10.0378 1.76507 10.0842 2.51561 9.64561 3.01371C9.3311 3.36995 8.96495 3.68028 8.61289 4.02035Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.44e2adcff3e27470c2b6f9c467306204.svg";
export { ForwardRef as ReactComponent };